import store from "@/store/index";

const PLATFORM_READER = 'FoxitReader';

export function setRootClassName(platform) {
	if (platform === 'FoxitReader') {
		document.documentElement.classList.add('from-reader');
	}
}

export function isFromReader() {
	return store.appStore.platform === PLATFORM_READER;
}